import React, { useEffect, useState } from 'react';
import api from '@/services/api';

const cache = new Map();

const fetchLogo = (key) => {
  if (!cache.has(key)) {
    cache.set(key, api.get('/logo-data', { params: { key } })
      .then(r => r.data?.data_uri || null)
      .catch(() => { cache.delete(key); return null; }));
  }
  return cache.get(key);
};

// Renders an R2-stored logo by key (e.g. "logos/3/clients/18_x.png"); renders nothing if unavailable.
export const StoredLogo = ({ logoKey, ...imgProps }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let alive = true;
    setSrc(null);
    if (logoKey) fetchLogo(logoKey).then(uri => { if (alive) setSrc(uri); });
    return () => { alive = false; };
  }, [logoKey]);
  if (!src) return null;
  return <img src={src} alt="" {...imgProps} />;
};

export default StoredLogo;
